<template>
  <div style="margin-bottom: -5px">
    <!--Without Drop Down-->
    <a :class="activeClassNoDropDown" v-if="menu.children.length === 0 "
       :href="mainPath"
       @click.prevent="parentMenuPath">
      <i :class='menu.menuIcon' class="offset-sm-1"></i>
      <span class="ml-2">{{ menu.menuName }}</span>
    </a>
    <!--With Drop Down-->
    <a :class="activeClass" v-if="menu.children.length > 0"
       :href='"#"' @click="openOrCloseMenu()">
      <i :class='menu.menuIcon' class="offset-sm-1"></i>
      <span class="ml-2">{{ menu.menuName }}</span>
      <span class="float-md-right">
                <i :class="btn" class="icon-background1"></i>
            </span>
    </a>
    <!--Used for Tree Structure for li tag-->
    <ul class="nav" v-if="menu.children.length > 0 && clicked ">
      <li v-for="(child, idx) of menu.children" v-bind:key="idx">
        <a :class="activeClassChild(child)" v-if="child.children.length ==0"
           :href="href1(child)"
           @click.prevent="childMenuPath(child, menu)"
           :ref="'menuChild_' + child.menuId"
           tabindex="0"
           style="white-space: normal; word-wrap: break-word; display: block; padding: 12px 15px;">
          <span class="margin-bottom-10"
                style="margin-left: 20px;float: left;margin-top: -20px"> {{ child.menuName }}</span>
        </a>
        <!--With Drop Down-->
        <a :class="activeClassChild(child)" v-if="child.children.length > 0"
           :href='"#"' @click.prevent="openOrCloseChildMenu(child.menuId)">
          <i :class='child.menuIcon' class="offset-sm-1"></i>
          <span class="ml-2">{{ child.menuName }}</span>
          <span class="float-md-right">
                <i :class="childBtn" class="icon-background1"></i>
            </span>
        </a>
        <!--Used for Tree Structure for li tag-->
        <ul class="nav" v-if="child.children.length > 0 && child.menuId==menuReg">
          <li v-for="(child2, idx) of child.children" v-bind:key="idx">

            <a :class="activeClassChild2nd(child2)"
               :href="href1(child2)"
               :ref="'menu2Child_' + child2.menuId"
               @click.prevent="child2ndMenuPath(child2, menu)"
               style="white-space: normal; word-wrap: break-word; display: block; padding: 15px 15px;">
          <span class="margin-bottom-10"
                style="margin-left: 20px;float: left;margin-top: -20px"> {{ child2.menuName }}</span>
            </a>

          </li>
        </ul>

      </li>
    </ul>
  </div>
</template>
<script>
import {bus} from '@/bus'
import store from "@/store";

export default {
  name: 'Menu',
  data() {
    return {
      clicked: false,
      childrenClicked: false,
      menuIsRestricted: false,
      submenuIsRestricted: false,
      menuPath: {},
      childClicked: false,
      menuReg: null,
      isMenuExpanded: false
    }
  },
  created() {
    bus.$on('menu-open', (m) => {
      if (m.id !== this.menu.syspk) {
        this.clicked = false;
      }
    });

    bus.$on('child-menu-open', (m) => {
      if (m.id !== this.menu.children.syspk) {
        this.childrenClicked = false;
      }
    });

    bus.$on('call-home-menu', this.homeMenu);
    if (store.state.isLoggedIn){
      this.redirectMenu()
    }

  },
  computed: {
    btn: function () {
      if (!this.clicked) return 'fa fa-plus-square fa-xs stroke-transparent custom-fa aln'
      else return 'fa fa-minus-square fa-xs stroke-transparent custom-fa aln'
    },
    childBtn: function () {
      if (!this.childrenClicked) return 'fa fa-plus-square fa-xs stroke-transparent custom-fa aln'
      else return 'fa fa-minus-square fa-xs stroke-transparent custom-fa aln'
    },
    mainPath: function () {
      return '#' + this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
    },
    activeClassNoDropDown: function () {
      if (this.menu.menuId === this.$store.state.childParentId && this.menu.parentMenuId === this.$store.state.parentMenuId)
        return 'nav-link text-left active'
      else return 'nav-link text-left ex1'
    },
    activeClass: function () {
      if (this.menu.menuId === this.$store.state.parentMenuId)
        return 'nav-link text-left active'
      else return 'nav-link text-left ex1'
    },
  },
  methods: {
    homeMenu() {
      let menuObject;

      const {homeDashboardMenuId} = this.$store.state.user;
      const roleLevelMenuId = this.$store.state.userRoleRestriction.homeDashboardMenuId;

      if (!homeDashboardMenuId) {
        menuObject = roleLevelMenuId;
        // console.log("Role level dashboard");
      } else {
        menuObject = homeDashboardMenuId;
        // console.log("User level dashboard");
      }

      const segments = menuObject.split('/');
      const lastSegment = segments.pop(); // Second-level menu ID
      const secondLastSegment = segments.pop(); // First-level menu ID
      const matchingChild = this.menu.children.find((child) => child.menuId === lastSegment);

      const firstLevelMenu = this.menu.children.find((child) => child.menuId === secondLastSegment);
      if (firstLevelMenu && !this.isMenuExpanded) {
        this.isMenuExpanded = true;
        this.clicked = true;
        this.menuReg = firstLevelMenu.parentMenuId;

        let secondLevelMenu = firstLevelMenu.children?.find((child) => child.menuId === lastSegment);


        this.$nextTick(() => {
          setTimeout(() => {
            if (secondLevelMenu) {
              this.clicked = true;
              this.menuReg = secondLevelMenu.parentMenuId;


              this.$nextTick(() => {
                setTimeout(() => {
                  this.clicked = true;
                  this.menuReg = secondLevelMenu.parentMenuId;

                  this.$nextTick(() => {
                    setTimeout(() => {
                      // console.log("inside the second level")
                      const secondLevelMenuElement = this.$refs['menu2Child_' + secondLevelMenu.menuId]?.[0];
                      // console.log("inside the second level value:", secondLevelMenuElement)

                      if (secondLevelMenuElement) {
                        secondLevelMenuElement.focus();
                      } else {
                        console.error("Second-level menu item not found in $refs or is not focusable.");
                      }
                    }, 200);
                  });
                }, 200);
              });
            } else {
              console.error("Second-level menu item not found.");
            }
          }, 200); // Small delay to ensure first-level is rendered
        });
      }
     /* else {
        console.error("First-level menu item not found.");
      }*/


      if (matchingChild) {
        this.clicked = true; // Expand parent menu
        this.menuReg = matchingChild.menuId; // Expand and highlight matching child menu
        this.$nextTick(() => {
          const matchingChildElement = this.$refs['menuChild_' + matchingChild.menuId]?.[0];
          if (matchingChildElement) {
            matchingChildElement.focus();
          } else {
            console.error("Menu item not found in $refs or is not focusable.");
          }
        });
      }
    },
    redirectMenu() {
      let menuObject = this.$store.state.redirectUrl;
      // console.log("setRedirectUrl", menuObject);

      const segments = menuObject.split('/');
      const lastSegment = segments.pop();       // Second-level menu ID
      const secondLastSegment = segments.pop(); // First-level menu ID
      const matchingChild = this.menu.children.find(child => child.menuId === lastSegment);

      const firstLevelMenu = this.menu.children.find(child => child.menuId === secondLastSegment);

      if (firstLevelMenu && !this.isMenuExpanded) {
        this.isMenuExpanded = true;
        this.clicked = true;
        this.menuReg = firstLevelMenu.parentMenuId;

        let secondLevelMenu = firstLevelMenu.children?.find(child => child.menuId === lastSegment);

        this.$nextTick(() => {
          setTimeout(() => {
            if (secondLevelMenu) {
              this.clicked = true;
              this.menuReg = secondLevelMenu.parentMenuId;

              this.$nextTick(() => {
                setTimeout(() => {
                  this.clicked = true;
                  this.menuReg = secondLevelMenu.parentMenuId;

                  this.$nextTick(() => {
                    setTimeout(() => {
                      // console.log("Inside second level");

                      const secondLevelMenuElement = this.$refs['menu2Child_' + secondLevelMenu.menuId]?.[0];
                      // console.log("Second-level menu element ref:", secondLevelMenuElement);

                      if (secondLevelMenuElement) {
                        // Trigger click instead of focus
                        secondLevelMenuElement.click();
                        secondLevelMenuElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

                      } else {
                        console.error("Second-level menu item not found in $refs.");
                      }
                    }, 200);
                  });
                }, 200);
              });
            } else {
              console.error("Second-level menu not found.");
            }
          }, 200);
        });
      } /*else {
        console.error("First-level menu item not found.");
      }*/

      if (matchingChild) {
        this.clicked = true;
        this.menuReg = matchingChild.menuId;

        this.$nextTick(() => {
          const matchingChildElement = this.$refs['menuChild_' + matchingChild.menuId]?.[0];

          if (matchingChildElement) {
            // Trigger click instead of focus
            matchingChildElement.click();
            matchingChildElement.scrollIntoView({ behavior: 'smooth', block: 'center' });

          } else {
            console.error("First-level menu item not found in $refs.");
          }
        });
      }
    }
    ,
    openOrCloseMenu() {
      this.clicked = !this.clicked
      bus.$emit('menu-open', {id: this.menu.syspk, clicked: this.clicked})
    },
    openOrCloseChildMenu(menuId) {
      if (this.menuReg !== menuId) {
        this.menuReg = menuId
        this.childrenClicked = true
      } else {
        this.menuReg = null
        this.childrenClicked = false
      }
      this.menuPath.p = this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      this.menuPath.pId = this.menu.menuId
      this.menuPath.c = menuId.menuPath + '/' + menuId.parentMenuId + '/' + menuId.menuId
      this.menuPath.cId = menuId.menuId
      this.$store.dispatch('loadMenuPath', this.menuPath)
      this.childClicked = true
    },
    href1(child) {
      return '#' + child.menuPath + '/' + child.parentMenuId + '/' + child.menuId
    },
    activeClassChild: function (child) {
      const currentPath = this.$route.path; // Get the current route path
      // console.log(currentPath)
      const lastValue = currentPath.split('/').pop();
      if (lastValue === child.menuId) { // Check for an exact match
        return 'nav-link text-left active'; // Highlight if route matches exactly
      } else {
        return 'nav-link text-left ex1';
      }
    },
    activeClassChild2nd: function (child) {
      const currentPath = this.$route.path; // Get the current route path
      // console.log(currentPath)
      const lastValue = currentPath.split('/').pop();
      if (lastValue === child.menuId) { // Check for an exact match
        return 'nav-link text-left active'; // Highlight if route matches exactly
      } else {
        return 'nav-link text-left ex1';
      }
    },
    async parentMenuPath() {
      this.$logClick({
        element: 'menu-navigation-button',
        action: 'menu-click',
        menuId: this.menu.parentMenuId,
        subMenuId: this.menu.menuId,
        route:this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      });
      this.menuPath.p = this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      this.menuPath.pId = this.menu.parentMenuId
      this.menuPath.cId = this.menu.menuId
      await this.$router.push(this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId)
      await this.$store.dispatch('loadMenuPath', this.menuPath)
    },
    async childMenuPath(child) {
      this.$logClick({
        element: 'menu-navigation-button',
        action: 'menu-click',
        menuId: this.menu.parentMenuId,
        subMenuId: this.menu.menuId,
        route:this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
        // menuId/submenuId will come from this.$route.params
      });
      this.menuPath.p = this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      this.menuPath.pId = this.menu.menuId
      this.menuPath.c = child.menuPath + '/' + child.parentMenuId + '/' + child.menuId
      this.menuPath.cId = child.menuId
      await this.$router.push(child.menuPath + '/' + child.parentMenuId + '/' + child.menuId)
      await this.$store.dispatch('loadMenuPath', this.menuPath)
      this.childClicked = true
    },
    async child2ndMenuPath(child) {
      this.$logClick({
        element: 'menu-navigation-button',
        action: 'menu-click',
        menuId: this.menu.parentMenuId,
        subMenuId: this.menu.menuId,
        route:this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
        // menuId/submenuId will come from this.$route.params
      });
      this.menuPath.p = this.menu.menuPath + '/' + this.menu.parentMenuId + '/' + this.menu.menuId
      this.menuPath.pId = child.parentMenuId
      this.menuPath.c = child.menuPath + '/' + child.parentMenuId + '/' + child.menuId
      this.menuPath.cId = child.menuId
      await this.$router.push(child.menuPath + '/' + child.parentMenuId + '/' + child.menuId)
      await this.$store.dispatch('loadMenuPath', this.menuPath)
      this.childClicked = true
    },

  },
  props: {
    menu: Object
  }
}
</script>
<style scoped>
.nav {
  display: block;
}

.nav-link {
  background-color: #3E3E3E;
  color: #D7D7D7;
  font-size: 14px;
  font-weight: normal;
  margin-left: -35px;
  @media (max-width: 768px) {
    margin-left: -15px;
  }
}

/*Tree Structure*/


ul li {
  margin-left: 20px;
  position: relative;
  font-size: 10px;
  text-align: left;
  margin-top: 12px;
  line-height: 11px;

}

/*Side long Line*/
ul li::before {
  content: " ";
  position: absolute;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 1px;
  background-color: white;
  top: 1px;
  bottom: -12px;
  left: -12px;
}

body > ul > li:first-child::before {
  top: 2px;
}

ul li:not(:first-child):last-child::before {
  display: none;
}

ul li:only-child::before {
  display: list-item;
  content: " ";
  position: absolute;
  width: 20px;
  background-color: white;
  top: 0px;
  bottom: 7px;
  height: 7px;
  left: -12px;
}

ul li::after {
  content: " ";
  position: absolute;
  left: -12px;
  width: 10px;
  height: 1px;
  background-color: darkgrey;
  top: 0px;
}

ul li:last-child::before {
  display: none;
}

a.ex1:hover, a.ex1:focus, a.ex1:active {
  color: white;
  font-weight: lighter;
}

a.active {
  color: white;
  font-weight: bold;
}

.icon-background1 {
  font-weight: lighter;
  padding-right: 10px;
  @media (max-width: 768px) {
    padding-left: 10px;
    float: right;
  }
}
</style>